import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Field, change } from 'redux-form'
import { trim, get } from 'lodash'
import {
  InputFieldReduxFormWrapper,
  SelectFieldReduxFormWrapper,
  CheckboxFieldReduxFormWrapper,
} from '@adc/ui-core'
import classNames from 'classnames/bind'
import { INDIVIDUAL_FORM_TYPE, FORM_NAME } from '../constants'
import {
  required,
  getErrorMsg,
  normalizeOwnership,
  allowNumbersAndDot,
  signerTitleOptions,
  getOwnershipValidators,
  renderOwnershipLabel,
  email as emailValidator,
} from '../utils/'
import { formatTitlelize } from '../../../../../util/formatters'
import styles from './styles.scss'
const cx = classNames.bind(styles)
const elmId = 'individual_form'
const errorMsg = getErrorMsg('Individual')

class IndividualForm extends Component {
  static propTypes = {
    formKey: PropTypes.string,
    entityType: PropTypes.string,
    showTitlesOnly: PropTypes.bool,
    fieldArraysIndex: PropTypes.number,
    interestedParties: PropTypes.array,
    isAutoCapitalize: PropTypes.bool,
    dispatch: PropTypes.func.isRequired,
  }

  static defaultProps = {
    showTitlesOnly: false,
  }

  render() {
    const {
      formKey,
      dispatch,
      entityType,
      showTitlesOnly,
      fieldArraysIndex,
      interestedParties,
      isAutoCapitalize,
    } = this.props

    const includeSignature = get(
      interestedParties[fieldArraysIndex],
      'includeSignature'
    )
    const individualTitle = get(
      interestedParties[fieldArraysIndex],
      'individualTitle'
    )

    const normalizeFunc = isAutoCapitalize ? formatTitlelize : trim

    return (
      <div
        className={cx(
          'root',
          showTitlesOnly ? 'closed' : 'opened',
          'ui',
          'form'
        )}
      >
        <div className={cx('field-wrapper')}>
          <Field
            name={`${formKey}.name`}
            type='text'
            label='Name'
            elmId={`${formKey}.${elmId}_name`}
            placeholder='Enter Name'
            validate={required({ msg: errorMsg.name })}
            onChange={(_e, value) =>
              dispatch(change(FORM_NAME, `${formKey}nameText`, value))
            } // eslint-disable-line
            normalizeOnBlur={normalizeFunc}
            className={cx('field')}
            component={InputFieldReduxFormWrapper}
          />
          <Field
            name={`${formKey}.nameText`}
            type='hidden'
            elmId={`${elmId}_nameText`}
            className={cx('field')}
            component={InputFieldReduxFormWrapper}
          />
        </div>
        <div className={cx('field-wrapper', 'title-and-ownership')}>
          <div className={cx('title-field')}>
            <Field
              name={`${formKey}.individualTitle`}
              type='select'
              label='Title'
              options={signerTitleOptions(entityType, `${formKey}.${elmId}`)}
              placeholder='Select'
              upward
              disabled={!entityType}
              validate={required({ msg: errorMsg.title })}
              elmId={`${formKey}.${elmId}_title`}
              className={cx('field')}
              component={SelectFieldReduxFormWrapper}
            />
            {individualTitle === 'OTHER' && (
              <Field
                name={`${formKey}.individualOtherTitle`}
                type='text'
                validate={required({ msg: errorMsg.title })}
                label='Other Title'
                normalizeOnBlur={trim}
                placeholder='Enter a title'
                elmId={`${formKey}.${elmId}_other_title`}
                className={cx('field')}
                component={InputFieldReduxFormWrapper}
              />
            )}
          </div>
          <div className={cx('ownership-field')}>
            <Field
              name={`${formKey}.individualOwnership`}
              type='text'
              label={renderOwnershipLabel(cx('u-pl-1'))}
              elmId={`${formKey}.${elmId}_ownership`}
              inputLabel='%'
              labelPosition='right'
              normalize={allowNumbersAndDot}
              normalizeOnBlur={normalizeOwnership}
              validate={getOwnershipValidators(INDIVIDUAL_FORM_TYPE)}
              className={cx('field')}
              component={InputFieldReduxFormWrapper}
            />
          </div>
        </div>
        <div className={cx('field-wrapper')}>
          <Field
            name={`${formKey}.includeSignature`}
            type='checkbox'
            elmId={`${formKey}.${elmId}_include_signature`}
            checkboxLabel='Include signature on the contract.'
            className={cx('field')}
            checked
            component={CheckboxFieldReduxFormWrapper}
          />
        </div>

        {Boolean(includeSignature) && (
          <div className={cx('field-wrapper')}>
            <Field
              name={`${formKey}.email`}
              label='Email'
              validate={[required({ msg: errorMsg.email }), emailValidator()]}
              normalizeOnBlur={trim}
              placeholder='Enter email'
              elmId={`${formKey}.${elmId}_enter_email`}
              className={cx('field')}
              component={InputFieldReduxFormWrapper}
            />
            <p>
              An email is required so the contract can be sent to all signing
              participants.
            </p>
          </div>
        )}
      </div>
    )
  }
}

export default connect()(IndividualForm)
